import { Typography } from '@material-ui/core';
import styled from 'styled-components';

import Button from '../Button';

export const Container = styled.div<{ $width?: string }>`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ $width }): string => $width || '450px'};
  padding: 30px;
  border-radius: 20px;
  background-color: white;
  outline: none;

  button {
    width: 100%;
    border-width: 2px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }): string => theme.spacers!.spacer02};

  svg {
    cursor: pointer;
  }
`;

export const Text = styled.div<{ $textWidth?: string }>`
  padding: ${({ theme }): string => `${theme.spacers?.spacer03} ${theme.spacers?.spacer02}`};
  margin-bottom: ${({ theme: { spacers } }): string => spacers!.spacer03};
  width: ${({ $textWidth }): string => $textWidth || '100%'};

  & > span {
    font-family: Graphik;
    font-size: 14px;
  }
`;

export const StyledText = styled.p<{ $textWidth?: string }>`
  width: ${({ $textWidth }): string => $textWidth || '360px'} !important;
  font-family: Graphik;
  font-size: 14px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: 0.01em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: ${({ theme: { spacers } }): string => spacers!.spacer03};
  padding: ${({ theme: { spacers } }): string => spacers!.spacer02};

  button {
    width: 100%;
  }
`;

export const Title = styled(Typography)`
  &.MuiTypography-h4 {
    font-family: Graphik;
    font-size: 32px;
    line-height: 125%;
    font-weight: 600;
    color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
  }
`;

export const FieldWrapper = styled.div`
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer06};
  padding: ${({ theme }): string => theme.spacers!.spacer02};
`;

export const StyledButton = styled(Button)`
  .TrekButton-normal {
    background: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
    color: ${({ theme }): string => theme.admanColors!.gray.dark.fg[0]};

    &:hover {
      background: ${({ theme }): string => theme.admanColors!.gray.dark.bg2[0]};
    }
  }

  .TrekButton-disabled {
    background: ${({ theme }): string => theme.admanColors!.gray.light.bg0[6]};
    color: ${({ theme }): string => theme.admanColors!.gray.light.fg[5]};
  }
`;
